module.exports = __webpack_public_path__ + "static/The_Crux.657c580f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/The_Crux.png
// module id = 452
// module chunks = 35783957827783